/* 动态路由 */

// import test from '@/router/test'//测试
import home from '@/router/home' // 首页
import companyManagement from '@/router/companyManagement' // 公司管理
import projectManagement from '@/router/projectManagement' // 项目管理
import patentManagement from '@/router/patentManagement' // 专利管理
import generalProcessManagement from '@/router/generalProcessManagement' // 通用流程
import processApprovalManagement from '@/router/processApprovalManagement' // 流程审批
import templateManagement from '@/router/templateManagement' // 模板管理
import adminManagement from '@/router/adminManagement' // 系统管理
import dev from '@/router/dev' // 开发相关

// 动态路由，通过权限筛选的路由
export default [...home, ...companyManagement, ...projectManagement,
  ...patentManagement, ...generalProcessManagement, ...processApprovalManagement,
  ...templateManagement, ...adminManagement
]
